/**
 * Utilidades para manejo de errores
 */

/**
 * Extrae el mensaje de error desde diferentes estructuras de respuesta del backend
 * @param {Error|Object} error - Objeto de error (de axios u otro)
 * @param {string} fallback - Mensaje por defecto si no se encuentra mensaje
 * @returns {string} Mensaje de error extraído
 */
export const getErrorMessage = (error, fallback = 'Ha ocurrido un error') => {
    return error?.response?.data?.message
        || error?.response?.data?.error
        || error?.message
        || fallback;
};

export default {
    getErrorMessage
};
